var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","stroke-width":2,"height":_vm.size,"width":_vm.size,"viewBox":"0 0 48 48"}},[_c('path',{attrs:{"d":"M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }